import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import ImageIcon from '@material-ui/icons/Image';
import './EditFloatWindowAbstract.css'



const wStyles = theme => ({
    textLink:{
        height:40,
        color:"white",
        width:"90%",
        fontFamily:"Microsoft JhengHei",
        borderStyle:"soild",
        borderWidth:1,
        borderColor:"black",
        backgroundColor:"#2783c4",
        textAlign:"center",
        fontSize:20,
        lineHeight:"30px",
        margin:5,
        '&:hover':{
            color:"black",
        },
    },
})


class EditFloatWindowAbstract extends Component {
    constructor(props){
        super(props)
        this.state={
            position:{
                x:300,
                y:400,
            },
            refPos:{
                x:0,
                y:0
            },
            divSize:{
                width:250,
                height:200,
            },
            refDivSize:{
                width:0,
                height:0
            },
            containerExtending:false,
            containerDragging:false,
            //selectImageID:null,
        }
        this.editFloatWindowRef = React.createRef()
        this.imageEditWindowRef = React.createRef()
    }

   

    componentDidUpdate(prevProps, prevState) {
        
        //console.log("con 0")
        
        if(this.state.containerExtending === false && this.state.containerDragging === true)
        {
            if(prevProps.mousePos !== this.props.mousePos)
            {
                //console.log("con 1")
                this.setNewContainerPosition()
            } 
        }
        else if(this.state.containerExtending === true && this.state.containerDragging === false)
        {
            if(prevProps.mousePos !== this.props.mousePos)
            {
                //console.log("con 2")
                this.setNewContainerSize()
            } 
        }
        else if(prevProps.size !== this.props.size)
        {
            //console.log("con 3")
            this.loadContainerSize()
        }

        if(prevProps.editToken !== this.props.editToken)
        {
            //console.log("con 4")
            this.setState({
                selectedTab:2
            })
        }
    }

    setNewContainerPosition() {

        let containerX = this.props.mousePos.x-this.state.refPos.x
        let containerY = this.props.mousePos.y-this.state.refPos.y

        let newPos = {
            x:containerX,
            y:containerY
        }

        this.setState({
            position:newPos,
        })
    }

    setNewContainerSize=()=>{

        let width = this.state.refDivSize.width+(this.props.mousePos.x-this.state.refPos.x)
        let height = this.state.refDivSize.height+(this.props.mousePos.y-this.state.refPos.y)

        if(width<250)
        {
            width = 250
        }

        if(height<200)
        {
            height = 200
        }

        let newSize = {
            width:width,
            height:height
        }
   
        this.setState({
            divSize:newSize
        })
       
    }

    extendAreaMouseDown=(e)=>{
        // console.log('extendAreaMouseDown')
        e.stopPropagation()
        this.setState({
            containerExtending:true,
            refPos:{
                x:e.clientX,
                y:e.clientY
            },
            refDivSize:this.state.divSize
        })   

        let msg ={
            conID:this.props.conID,
            containerExtending:true,
        }
        this.props.containerExtending(msg)
    }

    extendAreaMouseUp=(e)=>{
        e.stopPropagation()
        // console.log('extendAreaMouseUp')
        
        this.setState({
            containerExtending:false,
            
            refPos:{
                x:0,
                y:0
            },
        })  

        let msg ={
            conID:this.props.conID,
            containerExtending:false,
        }
        
        this.props.containerExtending(msg)

    }

 
    headerMouseDown=(e)=>{   
        e.stopPropagation()
        e.preventDefault()
        console.log('ControllerUnitContainer headerMouseDown')
     

        this.setState({
            containerDragging:true,
            refPos:{
                x:e.clientX-this.state.position.x,
                y:e.clientY-this.state.position.y
            }
        })   

        let msg ={
            conID:this.props.conID,
            containerDragging:true,
        }
        this.props.containerDragging(msg)
    }

    headerMouseUp=(e)=>{
        e.stopPropagation()
        this.setState({
            containerDragging:false,
            refPos:{
                x:0,
                y:0
            },
        })  

        let msg ={
            conID:this.props.conID,
            containerDragging:false,
            position:this.state.position
        }
        this.props.containerDragging(msg)
    }

    rowAreaOnContextMenu=(e,ID)=>{
        e.preventDefault()
        console.log("Selected Row ImageID : ",ID)
        let msg={
            ID : ID,
            pos:{
                x:e.clientX,
                y:e.clientY
            }
        }
        console.log("msg : ",msg)
        this.props.openContextManu(msg)
    }

    changeTitle=(e)=>{
        this.props.getAbstractTitle(e.target.value)
    }

    creatInputField=()=>{
        const {classes} = this.props;

        let textAreaStyle = {
            width:"100%",
        }
        let inputStyle = {
            width:"100%"
        }

        if(this.props.editingField === 1)
        {
            return(
                <div>
                    <div>
                        輸入標題
                    </div>
                    <input  style={inputStyle} type='text' value={this.props.eventDetail.Event_Title} onChange={(e)=>{this.props.getAbstractTitle(e.target.value)}} />
                </div>
            )
        }
        else if(this.props.editingField === 2)
        {
            return(
                <div>
                    <div>
                        輸入副標題
                    </div>
                    <input style={inputStyle} type='text' value={this.props.eventDetail.Event_SubTitle} onChange={(e)=>{this.props.getAbstractSubTitle(e.target.value)}} />
                </div>
            )
        }
        else if(this.props.editingField === 3)
        {
           
            return(
                <div>
                    <div>
                        輸入簡介
                    </div>
                    <textarea style={textAreaStyle} onChange={(e)=>{this.props.getAbstractStory(e.target.value)}} >
                        {this.props.eventDetail.Event_Story}
                    </textarea>
                </div>
            )
        }
        else if(this.props.editingField === 4)
        {
           let selectEditContainerArea = {
                display: 'flex',
                flexDirection: 'column',
                borderBottom:"1px solid black",
                fontFamily: "Microsoft JhengHei",
            }

            let rowArea = {
                display: 'flex',
            }
        
            let columnHeader = {
                width:"50%",
                border:"1px solid black",
                fontFamily: "Microsoft JhengHei",
            }

            let addContainerButtonArea = {
                display: 'flex',
                flexDirection: 'column',
                borderBottom:"1px solid black",
            }
           
            return(
                <div style={selectEditContainerArea}> 
                    <div>編輯專題標題影像</div>
                    <div style={addContainerButtonArea}>
                        <Button className={classes.textLink} startIcon={<ImageIcon />} onClick={this.addNewImage}>
                            新增圖片區塊    
                        </Button>               
                    </div>
                    <div style={rowArea}>
                        <div style={columnHeader}>ID</div>
                        <div style={columnHeader}>影像順序</div>
                        <div style={columnHeader}>轉場秒數</div>
                        <div style={columnHeader}>轉場特效</div>           
                    </div> 
                    {this.createImageList()}
                </div>
            )
        }
    }

    createImageList = () =>{
        if(this.props.eventDetail.Event_Images)
        {
            return(
                this.props.eventDetail.Event_Images.map(image=>{
                    return(                 
                        <div className={"rowArea"} onContextMenu={(e)=>this.rowAreaOnContextMenu(e,image.imageID)}>
                            <div className={"rowCell"} onClick={()=>this.selectImageID(image.imageID)}>{image.imageID}</div>
                            <div className={"rowCell"} >{image.order}</div>
                            <div className={"rowCell"} >{image.transitionTime}</div>
                            <div className={"rowCell"} >{image.transitionMethod}</div>          
                       </div>      
                    )
                })
            )
        }
        else
        {
            return null
        }
    }

    addNewImage=()=>{
        let msg = null
        this.props.openImageEditor(msg)
    }

    selectImageID=(id)=>{
       this.props.openImageEditor(id)
    }

    render(){
        
        let CompositionContainerStyle ={
            width:this.state.divSize.width,
            height:this.state.divSize.height,
            position:'fixed',
            left:this.state.position.x,
            top:this.state.position.y,
            //zIndex:this.props.zIndex,
            backgroundColor:"white",
            border:'3px solid',
            borderColor:'black',
            boxSizing:'border-box',
            display: 'flex',
            flexDirection: 'column',
            zIndex:1000,
        }

        const extendFunctionAreaStyle = {
            width:'20px',
            height:'20px',
            position:'absolute',
            right:'0px',
            bottom:'0px',
            userSelect:'none',
            color:"black",
            cursor:'nw-resize'
        }

        const buffeArea = {
            width:"100%",
            height:"30px",
        }

        const headerStyle = {
            width:'100%',
            height:'25px',
            borderBottom:'1px solid',
            borderColor:'gray',
            backgroundColor:'#3680cf',
            display:'flex',
            paddingTop:'2px',
            paddingLeft:'2px',
            userSelect:'none',
            cursor:'move',
        }


        return(
            <div style={CompositionContainerStyle} ref={this.editFloatWindowRef}> 
                <div style={headerStyle} onMouseDown={this.headerMouseDown} onMouseUp={this.headerMouseUp}>
                    <div  className={"headerTab"} >專題簡介編輯</div>     
                </div>
                {this.creatInputField()}
                <div style={buffeArea}/>
                <div style={extendFunctionAreaStyle} onMouseDown={this.extendAreaMouseDown} onMouseUp={this.extendAreaMouseUp} >
                    &#9499;
                </div> 
            </div>
        )
    }
}

export default withStyles(wStyles)(EditFloatWindowAbstract)